<template>
  <div id="app" v-on:scroll="handleScroll">
    <Menu :color="color" :key="color"/>
    <Banner/>
    <MiddleBanner/>
    <Caracteristicas/>
    <BannerSlider/>
    <Beneficios/>
    <Footer/>
  </div>
</template>

<script>
import Menu from './components/Menu.vue'
import Banner from './components/Banner.vue'
import MiddleBanner from './components/MiddleBanner.vue'
import Caracteristicas from './components/Caracteristicas.vue'
import BannerSlider from './components/BannerSlider.vue'
import Beneficios from './components/Beneficios.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    Menu,
    Banner,
    MiddleBanner,
    Caracteristicas,
    BannerSlider,
    Beneficios,
    Footer
  },
  data() {
    return {
        color: '',
        logo: ''
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll(){
      console.log(window.scrollY)
        if(window.scrollY > '100'){
            this.color='black';
        } else {
            this.color='';
        }
    }
    },
}
</script>

<style>
#app {
  font-family: urbane-rounded, sans-serif;
  font-weight: 500;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  overflow-x: hidden;
}
body{
  overflow-x: hidden;
}
.relative{
  position: relative;
}
@media (min-width: 1600px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
      max-width: 1450px !important;
  }
}
</style>
